/*
*  page transitions
*/
import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
let Twig = require ('twig')

export default class extends Controller {
    WhoIs;

    initialize(){
        super.initialize();
        Twig.twig({
            id: "transition", //controller name
            href: "/twig/transition.twig",// loadable twig
            async: false
        });
    }

    /* MANAGERS PAGES */






    connect(){

    }
}
